document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_Header', () => ({
    isStuck: false,
    overlayHeaderWithSticky: null,
    overlayTextColor: null,

    // TNS additions
    infoOpen: false,
    audioPlaying: false,
    stickyHidden: false,
    nowPlayingShown: false,

    init() {
      this.overlayHeaderWithSticky =
        this.$root.dataset.overlayHeaderWithSticky === 'true';

      if (this.overlayHeaderWithSticky) {
        this.setUpOverlayWithSticky();
      } else {
        this.setUpStickyDetection();
      }

      // On scroll up: hide the header when scrolling down past a small
      // threshold, reveal when scrolling up. Only active when the section
      // is configured for it. Disabled while the info panel is open.
      if (this.$root.dataset.stickyType === 'on_scroll_up') {
        this.setUpOnScrollUp();
      }

      // Close Info panel on Escape
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.infoOpen) this.infoOpen = false;
      });

      // Make the info panel adopt the current page's primary colour
      // scheme. Without this, the panel always paints scheme1 (ivory)
      // — which flashes against coloured pages (brown article, etc.)
      // when it slides down. We pull the data-color-scheme of the first
      // coloured section inside <main> and apply it to the panel + wrap.
      this.applyPageColorSchemeToInfoPanel();

      // Lock body scroll on mobile while the info panel is open, so the
      // panel is the only scrollable surface (panel-first scrolling).
      this.$watch('infoOpen', (open) => {
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (open && isMobile) {
          document.body.classList.add('tns-info-locked');
        } else {
          document.body.classList.remove('tns-info-locked');
        }
      });

      // When playback starts, show the mobile "Now Playing" toast. We
      // reset on each transition to true so it reappears on every play
      // (even if the user dismissed a previous instance with ×).
      this.$watch('audioPlaying', (playing) => {
        if (playing) this.nowPlayingShown = true;
      });

      // Persistent audio across pages using sessionStorage + MediaSession.
      this.restoreAudioState();

      // After a successful newsletter signup the page reloads; if the
      // success message is present, auto-open the info panel so the
      // visitor sees the "ARIGATOU:-)" confirmation.
      if (document.querySelector('[data-news-success]')) {
        this.infoOpen = true;
      }
    },

    applyPageColorSchemeToInfoPanel() {
      // Find the colour scheme of the dominant content section on the
      // current page (the first element inside <main> that declares a
      // data-color-scheme). Apply that scheme to the info panel + wrap
      // so the panel matches the page's background instead of always
      // painting scheme1 (ivory).
      try {
        var main = document.querySelector('main') || document.body;
        if (!main) return;
        // Look for the first descendant that explicitly sets a scheme.
        // Skip any header-group / footer-group children (those are
        // typically scheme1 chrome, not the main content surface).
        var contextEl = null;
        var candidates = main.querySelectorAll('[data-color-scheme]');
        for (var i = 0; i < candidates.length; i++) {
          var c = candidates[i];
          // Skip the chrome groups; we want the actual content.
          if (c.closest('[class*="header-group"]')) continue;
          if (c.closest('[class*="footer-group"]')) continue;
          contextEl = c;
          break;
        }
        if (!contextEl) return;
        var scheme = contextEl.getAttribute('data-color-scheme');
        if (!scheme) return;
        var panel = this.$root.querySelector('.tns-info-panel');
        var wrap = this.$root.querySelector('.tns-info-wrap');
        if (panel) panel.setAttribute('data-color-scheme', scheme);
        if (wrap)  wrap.setAttribute('data-color-scheme', scheme);
      } catch (e) {
        // Soft-fail — info panel still renders, just with its default scheme.
      }
    },

    setUpOnScrollUp() {
      const SHOW_THRESHOLD = 8;   // ignore tiny up-jitters
      const HIDE_THRESHOLD = 8;   // ignore tiny down-jitters
      const REVEAL_AT_TOP = 80;   // always show within first 80px from top
      let lastY = window.scrollY || 0;

      const onScroll = () => {
        const y = window.scrollY || 0;
        const dy = y - lastY;

        if (this.infoOpen) {
          this.stickyHidden = false;
          lastY = y;
          return;
        }

        if (y < REVEAL_AT_TOP) {
          this.stickyHidden = false;
        } else if (dy > HIDE_THRESHOLD) {
          this.stickyHidden = true;
        } else if (dy < -SHOW_THRESHOLD) {
          this.stickyHidden = false;
        }
        lastY = y;
      };

      window.addEventListener('scroll', onScroll, { passive: true });
    },

    setUpStickyDetection() {
      const positionerEl = document.createElement('div');
      positionerEl.id = 'sticky-positioner';
      positionerEl.style.position = 'absolute';
      positionerEl.style.top = '0';
      positionerEl.style.left = '0';
      positionerEl.style.width = '1px';
      positionerEl.style.height = '1px';
      positionerEl.style.pointerEvents = 'none';

      const section = this.$root.closest('.shopify-section');
      if (section && section.parentNode) {
        section.parentNode.insertBefore(positionerEl, section);
      } else {
        document.body.insertBefore(positionerEl, document.body.firstChild);
      }

      const observer = new IntersectionObserver(([entry]) => {
        this.isStuck = entry.intersectionRatio === 0;
      });
      observer.observe(positionerEl);
    },

    setUpOverlayWithSticky() {
      const positionerEl = document.createElement('div');
      positionerEl.id = 'sticky-positioner';

      document.body.insertBefore(
        positionerEl,
        this.$root.closest('.shopify-section')
      );

      const observer = new IntersectionObserver(([e]) => {
        e.intersectionRatio === 0
          ? (this.isStuck = true)
          : (this.isStuck = false);
      });

      observer.observe(positionerEl);

      this.overlayTextColor = this.$root.dataset.overlayTextColorScheme;

      this.updateColorScheme(this.isStuck);

      this.$watch('isStuck', (value) => {
        this.updateColorScheme(value);
      });
    },

    updateColorScheme(isStuck) {
      if (isStuck) {
        this.$refs.header.setAttribute('data-color-scheme', '');
        this.$refs.header.classList.remove('bg-transparent');
        this.$refs.header.classList.add('bg-scheme-background');
      } else {
        this.$refs.header.setAttribute(
          'data-color-scheme',
          this.overlayTextColor
        );
        this.$refs.header.classList.remove('bg-scheme-background');
        this.$refs.header.classList.add('bg-transparent');
      }
    },

    audioToggle(event) {
      const a = document.getElementById('tns-header-audio');
      this.audioPlaying = !this.audioPlaying;
      if (a) {
        if (this.audioPlaying) {
          a.play().catch(() => {
            this.audioPlaying = false;
            this.clearAudioState();
          });
          this.persistAudioState(true, a.currentTime);
          a.addEventListener('timeupdate', this.onTimeUpdate);
        } else {
          a.pause();
          this.persistAudioState(false, a.currentTime);
        }
      }
    },

    onTimeUpdate() {
      const a = document.getElementById('tns-header-audio');
      if (!a) return;
      try {
        sessionStorage.setItem('tns_audio_time', String(a.currentTime));
      } catch (e) {}
    },

    persistAudioState(playing, time) {
      try {
        sessionStorage.setItem('tns_audio_playing', playing ? '1' : '0');
        sessionStorage.setItem('tns_audio_time', String(time || 0));
      } catch (e) {}
    },

    clearAudioState() {
      try {
        sessionStorage.removeItem('tns_audio_playing');
        sessionStorage.removeItem('tns_audio_time');
      } catch (e) {}
    },

    restoreAudioState() {
      const a = document.getElementById('tns-header-audio');
      if (!a) return;

      let wasPlaying = '0';
      let savedTime = '0';
      try {
        wasPlaying = sessionStorage.getItem('tns_audio_playing') || '0';
        savedTime = sessionStorage.getItem('tns_audio_time') || '0';
      } catch (e) {}

      const t = parseFloat(savedTime) || 0;
      if (t > 0) {
        const setTime = () => {
          try { a.currentTime = t; } catch (e) {}
        };
        if (a.readyState >= 1) setTime();
        else a.addEventListener('loadedmetadata', setTime, { once: true });
      }

      // Persist time on pagehide so we don't lose it on unload.
      window.addEventListener('pagehide', () => {
        this.persistAudioState(!a.paused, a.currentTime);
      });

      if (wasPlaying !== '1') return;

      // Resume strategy: attempt play immediately. If the browser blocks
      // autoplay, do NOT clear state — keep the "wants to be playing" flag
      // and queue another attempt on the next user interaction. That way
      // a click on a link or anywhere on the page resumes playback, and
      // each subsequent navigation also keeps trying.
      const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'click'];
      const onInteractionResume = () => {
        a.play()
          .then(() => {
            this.audioPlaying = true;
            a.addEventListener('timeupdate', this.onTimeUpdate);
            removeInteractionListeners();
          })
          .catch(() => {
            // Still blocked; the listener stays armed for the next gesture.
          });
      };
      const removeInteractionListeners = () => {
        interactionEvents.forEach((ev) =>
          window.removeEventListener(ev, onInteractionResume, true)
        );
      };
      const armInteractionListeners = () => {
        interactionEvents.forEach((ev) =>
          window.addEventListener(ev, onInteractionResume, { capture: true, passive: true })
        );
      };

      const tryResume = () => {
        a.play()
          .then(() => {
            this.audioPlaying = true;
            a.addEventListener('timeupdate', this.onTimeUpdate);
          })
          .catch(() => {
            // Autoplay blocked. Keep state, arm listeners for next gesture.
            armInteractionListeners();
          });
      };

      if (a.readyState >= 2) {
        tryResume();
      } else {
        a.addEventListener('canplay', tryResume, { once: true });
        try { a.load(); } catch (e) {}
        // Also arm listeners now in case canplay never fires before user
        // interacts (e.g. slow network).
        armInteractionListeners();
      }
    },
  }));
});
